import { SureIcon } from '@sure-ui/components/icon'
import type { Plugin } from 'vue'

export default [
  SureIcon
] as Plugin[]
